module.exports = __webpack_public_path__ + "static/media/android_color.6308890b.svg";